// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';

import { tagsInitialState, TagsState } from './tagsInitialState';
import { createTagsSlice, TagsActions } from './createTagsSlice';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la balance comptable.
 */
export const useTagsStore = create<TagsState & TagsActions>()(
  persist(combine(tagsInitialState, createTagsSlice as any), {
    name: 'tags-store',
  }),
);
